module.exports = __webpack_public_path__ + "img/2.c3f23f00.png";